import { Component, OnInit, ChangeDetectorRef, Input, OnDestroy } from '@angular/core';
import { RoutePlannerService } from '../../services/route-planner/route-planner.service';
import { RoutePlannerDataModel } from '../../models/route-model';
import { PrintData } from '../../models/route-print-model';
import { RouteSignpostList, RouteLeg } from '../../models/route-signposts-model';
import { RouteSignpostsService } from '../../services/route-signposts/route-signposts.service';
import { RoutePlannerPrintService } from '../../services/route-planner-print/route-planner-print.service';
import { SummaryData } from '../../models/route-summary-model';
import { EventsService } from 'src/app/core/services/events.service';
import { GoogleMapType } from 'src/app/modules/google-map/enums/google-map-enum';
import { PrintRoutePlanner } from 'src/app/core/events/print-events';
import { BaseRouterComponent } from 'src/app/modules/aa-core/components/base-router/base-router.component';
import { AARouterURL } from 'src/app/modules/app-routing/enums/routing.enum';
import { ActivatedRoute, Router } from '@angular/router';
import { AppUtilityService } from 'src/app/core/services/app-utility/app-utility.service';
import { SeoMetaService } from 'src/app/modules/aa-core/services/seo-meta-service';

@Component({
    selector: 'aa-route-print-preview',
    templateUrl: './route-print-preview.component.html',
    styleUrls: ['./route-print-preview.component.scss'],
    standalone: false
})
export class RoutePrintPreviewComponent extends BaseRouterComponent implements OnInit, OnDestroy {

  public routeDataModel: RoutePlannerDataModel;
  public routeSignpostList: RouteSignpostList;
  public mapSettings: any;
  public selectedSummaryData: SummaryData;
  public hideSignPostsModel: any;

  @Input() printable = false;
  @Input() mapType: GoogleMapType = GoogleMapType.ROUTE_PRINT_MAP;

  private mapData: PrintData;
  private directionMapData: PrintData;

  constructor(private routePlannerService: RoutePlannerService,
    private cdr: ChangeDetectorRef,
    private eventsService: EventsService,
    private routePrintService: RoutePlannerPrintService,
    private routeSignpostsService: RouteSignpostsService,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    public appUtilityService: AppUtilityService,
    public seoService: SeoMetaService) {
    super(activatedRoute, router, appUtilityService, seoService);
    this.routerType = AARouterURL.PRINT_PREVIEW;
    this.applySiteTag();
  }

  ngOnInit() {
    this.loadParams();
    this.applySEO();

    this.mapSettings = this.routePrintService.printModel.MapSettings;
    // this.eventsService.on(PrintRoutePlanner.UPDATE_PRINT_PREVIEW, this.onUpdatePrintSettings);
    this.eventsService.on(PrintRoutePlanner.CLOSE_PRINT_PREVIEW, this.onClosePrintPreview);
    this.onUpdateMap();
  }

  public initMap(params: any): void { }

  get hideSignPosts() {
    return this.routePrintService.printModel.HideSignPosts;
  }

  set hideSignPosts(value) {
    this.routePrintService.printModel.HideSignPosts = value;
  }

  ngOnDestroy() {
    this.unSubscribeObservableEvents();
    // this.eventsService.remove(PrintRoutePlanner.UPDATE_PRINT_PREVIEW, this.onUpdatePrintSettings);
    this.eventsService.remove(PrintRoutePlanner.CLOSE_PRINT_PREVIEW, this.onClosePrintPreview);
  }

  printMap() {
    this.routePrintService.print();
    this.apply();
  }

  private onClosePrintPreview = () => {
    this.routePrintService.printModel.resetSignPostFlag();
    this.routeSignpostList.RouteSignpost.forEach(routeItem => {
      routeItem.hideAllMap();
    });
  }

  // private onUpdatePrintSettings = (data: any) => {
  //   if (data && data.hasOwnProperty('signPostChanged')) {
  //     this.hideSignPosts = data.signPostChanged;
  //     this.apply();
  //   } else if (data.hasOwnProperty('printable') && this.printable) {
  //     this.routeDataModel = this.routePlannerService.routeDataModel;
  //     this.routeSignpostList = this.routeSignpostsService.routeSignpostList;
  //     this.selectedSummaryData = this.routePrintService.selectedSummaryData;
  //     this.apply();
  //   }
  // }

  private onUpdateMap = () => {
    this.routeDataModel = this.routePlannerService.routeDataModel;
    this.routeSignpostList = this.routeSignpostsService.routeSignpostList;
    this.selectedSummaryData = this.routePrintService.selectedSummaryData;
    // this.eventsService.dispatch(HybridMapEvents.UPDATE_MAP, { mapType: this.mapType, data: this.getMapData() });
    // this.apply();
  }

  onSignPostChange(value) {
    this.hideSignPosts = value;
    this.apply();
  }

  apply() {
    setTimeout(() => {
      this.cdr.detectChanges();
    }, 10);
  }

  public updateMapSetting(value) {
    this.mapSettings.type = value;
    this.apply();
  }

  public toggleMap(direction: RouteLeg) {
    direction.showGoogleMap = !direction.showGoogleMap;
    this.apply();
  }
  public getMapData(): PrintData {
    this.mapData = new PrintData();
    this.mapData.From = this.routeDataModel.FromLocation;
    this.mapData.To = this.routeDataModel.ToLocation;
    return this.mapData;
  }
  public getMapDataForDirection(direction: RouteLeg): PrintData {
    this.directionMapData = new PrintData();
    this.directionMapData.From = this.routeDataModel.FromLocation;
    this.directionMapData.To = this.routeDataModel.ToLocation;
    this.directionMapData.Direction = direction;
    this.directionMapData.ShowDirection = true;
    return this.directionMapData;
  }
  
  trackByFn(index: number): number {
    return index;
  }
}
